import { render, staticRenderFns } from "./RecursiveList.vue?vue&type=template&id=7a23961f&scoped=true"
import script from "./RecursiveList.vue?vue&type=script&lang=js"
export * from "./RecursiveList.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RecursiveList.vue?vue&type=style&index=1&id=7a23961f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23961f",
  null
  
)

export default component.exports